import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900",
      "data-cy": "create_user"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Common.userCreateHead')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.valid || _vm.loading,
            "id": "save_user",
            "data-cy": "save_user"
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VForm, {
    ref: "form",
    staticClass: "user-form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VRow, {
    staticClass: "pl-1 pb-0 pr-1",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VCardText, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-0 pt-0 pr-0 mr-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('h4', {
    staticClass: "pt-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.tenant')) + ":")])])], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "first_name",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.firstName'),
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "autofocus": ""
    },
    model: {
      value: _vm.createdUser.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.createdUser, "firstName", $$v);
      },
      expression: "createdUser.firstName"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "last_name",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.lastName'),
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.createdUser.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.createdUser, "lastName", $$v);
      },
      expression: "createdUser.lastName"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "email_address",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.email'),
      "rules": _vm.emailRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.createdUser.email,
      callback: function ($$v) {
        _vm.$set(_vm.createdUser, "email", $$v);
      },
      expression: "createdUser.email"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-1",
    attrs: {
      "cols": "12",
      "md": "11"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.properties')))])])], 1), _vm._l(_vm.userKeyValue, function (kv, i) {
    return _c(VRow, {
      key: i,
      attrs: {
        "align": "top"
      }
    }, [_c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "sm": "5"
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": _vm.dataCyFromPropertyKey(kv.key, 'user_property'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('accMgmt.user.propertyKey'),
        "rules": _vm.requiredRuleKeyValue(kv),
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.$refs['form'].validate();
        }
      },
      model: {
        value: kv.key,
        callback: function ($$v) {
          _vm.$set(kv, "key", $$v);
        },
        expression: "kv.key"
      }
    })], 1), _c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "sm": "7"
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": _vm.dataCyFromPropertyKey(kv.key, 'property_value'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('accMgmt.user.propertyValue'),
        "rules": _vm.requiredRuleKeyValue(kv),
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.$refs['form'].validate();
        }
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "data-cy": "add_keyValuePair",
              "color": _vm.color,
              "prepend-icon": "fa-plus",
              "title": _vm.$i18n_t('Common.addNew')
            },
            on: {
              "click": function ($event) {
                return _vm.addKeyValuePair();
              }
            }
          }), _vm._v("\n                     \n                    "), _c('core-button', {
            attrs: {
              "data-cy": "delete_keyValuePair",
              "color": _vm.color,
              "prepend-icon": "fa-trash-alt",
              "title": _vm.$i18n_t('Common.delete')
            },
            on: {
              "click": function ($event) {
                return _vm.removeKeyValuePair(i);
              }
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: kv.value,
        callback: function ($$v) {
          _vm.$set(kv, "value", $$v);
        },
        expression: "kv.value"
      }
    })], 1)], 1);
  }), _c(VRow, {
    attrs: {
      "align": "top"
    }
  }, [_c('p', {
    staticClass: "card-description mt-2 ml-3"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.titlePropertyFieldHint')))])]), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('Common.drawer.accountMgmtPermissionsGroup')))])]), !_vm.createdUser.scope ? _c(VCol, {
    staticClass: "pa-1 mb-4",
    attrs: {
      "cols": "12"
    }
  }, [_c(VInput, {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "value": _vm.createdUser.scope,
      "rules": _vm.requiredRule
    }
  }), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.selectedScope')))]), _vm.tenantDetails ? _c('core-tenant-scope-tree', {
    attrs: {
      "data-cy": "tenant_scope_tree",
      "activeScopeId": _vm.tenantDetails.scopeId,
      "subject": "UserManagement",
      "action": "create"
    },
    on: {
      "update": _vm.didSelectScope
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.createdUser.scope ? _c(VCol, {
    staticClass: "px-1 py-0",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('core-tenant-scopes-permissions-list', {
    attrs: {
      "loading": !_vm.createdUser.id && _vm.createdUser.access.length === 0,
      "userAccess": _vm.createdUser.access
    },
    on: {
      "updatedUserAccess": _vm.updatedUserAccess
    }
  })], 1) : _vm._e()], 1), _c(VRow, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-password-field', {
    attrs: {
      "data-cy": "password_field",
      "label": _vm.$i18n_t('Common.password'),
      "rules": _vm.passwordRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "autocomplete": "new-password",
      "show-password": "",
      "required": ""
    },
    model: {
      value: _vm.createdUser.password,
      callback: function ($$v) {
        _vm.$set(_vm.createdUser, "password", $$v);
      },
      expression: "createdUser.password"
    }
  })], 1)], 1)], 2)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };